import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as PaymentLogo } from "../assets/img/illustrations/oc-money-profits.svg";

function PaymentFailed() {
  return (
    <div className="w-100">
      <>
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "70vh", fontFamily: "Inter, sans-serif" }}>
          <div className="text-center">
            <PaymentLogo style={{ maxHeight: "6rem", marginBottom: "2rem" }} />
            <h1 className="text-danger mb-3" style={{ fontSize: "2.5rem" }}>
              Payment Failed!
            </h1>
            <Link to="/dashboard">
              <button className="btn btn-primary">Go To Dashboard</button>
            </Link>
          </div>
        </div>
      </>
    </div>
  );
}

export default PaymentFailed;
